module.exports = __webpack_public_path__ + "images/home/product/sign-up-arrow-af4bd4e19ac9ff470375da464c120daf.png";